import { useState } from "react";
import { useGlobalContext } from "../../../../../../Context/Context";
import Button from "../../../../../Custom/Button/Button";
import axios from "axios";

const numberRegex = /^\d*$/;

const styles = { button: { padding: "5px 30px", fontWeight: "bold" } };
const emptyItem = { sadrzaj: "", kom: "" };

function ButtonsAddItem({ setCurrentState, setNewData, sredstvoId }) {
  const [newItem, setNewItem] = useState(emptyItem);
  const [loading, setLoading] = useState(false);
  const { dictionary, baseUrl } = useGlobalContext();

  const handleChangeInput = (value, key) => {
    if (key === "kom" && !numberRegex.test(value)) return;
    setNewItem((prev) => ({ ...prev, [key]: value }));
  };

  const handleSacuvaj = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${baseUrl}/spp/add_custom_stavka.php`,
        {
          sredstvo_id: sredstvoId,
          naziv: newItem.sadrzaj,
          kolicina: Number(newItem.kom),
        },
      );
      if (data.status === 200) {
        setNewData((prev) => ({
          ...prev,
          stavke: [
            ...prev.stavke,
            {
              id: data.id,
              naziv: newItem.sadrzaj,
              kolicina_trenutna: Number(newItem.kom),
              kolicina_min: Number(newItem.kom),
              custom: true,
            },
          ],
        }));
        setCurrentState("EDIT");
      } else {
        alert("Greška pri dodavanju stavke.");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = !newItem.kom || newItem.kom === "0" || !newItem.sadrzaj;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginTop: "15px",
      }}
    >
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
        <div style={{ width: "90%" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px",
            }}
          >
            {dictionary["nazivStavkeKojuDodajete"]}
          </div>
          <input
            value={newItem.sadrzaj}
            onChange={(e) => handleChangeInput(e.target.value, "sadrzaj")}
            style={{
              height: "40px",
              padding: "10px",
              fontSize: "16px",
              width: "100%",
            }}
          />
        </div>
        <div style={{ width: "10%" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px",
            }}
          >
            {dictionary["komada"]}
          </div>
          <input
            value={newItem.kom}
            onChange={(e) => handleChangeInput(e.target.value, "kom")}
            style={{
              height: "40px",
              padding: "10px",
              fontSize: "16px",
              width: "100%",
            }}
          />
        </div>
      </div>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <div onClick={() => setCurrentState("EDIT")}>
          <Button activation={true} style={styles.button}>
            {dictionary["odustani"]}
          </Button>
        </div>
        <div
          onClick={isDisabled || loading ? undefined : handleSacuvaj}
          style={{ opacity: isDisabled || loading ? 0.5 : 1 }}
        >
          <Button
            isDisabled={isDisabled || loading}
            activation={true}
            style={styles.button}
          >
            {dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ButtonsAddItem;
